module.exports = __webpack_public_path__ + "img/ext_llanoline.cc816797.png";